import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import Home from "./pages/Home";
import Signin from "./pages/Signin";
import Buy from "./pages/Buy";
import Sell from "./pages/Sell";
import About from "./pages/About";
import Layout from "./components/layout/Layout";
import FourZeroFour from "./pages/FourZeroFour";
// import Join from "./pages/Join";
// import Dashboard from "./pages/Dashboard";
// import Profile from "./pages/Profile";

// import Contact from "./pages/Contact";
// import Faq from "./pages/Faq";
// import Group from "./components/group/GroupList";
// import EventPage from "./components/event/EventList";
// import Terms from "./pages/Terms";
// import Privacy from "./pages/Privacy";
// import EventCreate from "./components/event/EventCreate";
// import PendingEvents from "./components/event/EventListPending";
// import UpdateEvent from "./components/event/EventUpdate";
// import Create from "./components/group/GroupCreate";
// import Delete from "./components/group/GroupDelete";
// import Edit from "./components/group/GroupUpdate";

// import Admin from "./pages/Admin";

import { signinComponentLoader } from "./lib/bandung/components/Signin/SigninComponent";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route
        path="signin"
        element={<Signin />}
        loader={signinComponentLoader}
      />
      <Route path="buy" element={<Buy />} />
      <Route path="sell" element={<Sell />} />
      <Route path="aboutus" element={<About />} />
      {/* <Route path="join" element={<Join />} />
      <Route path="dashboard" element={<Dashboard />}>
        {dashboardRoutes}
      </Route>
      <Route path="profile" element={<Profile />}>
        {profileRoutes}
      </Route>
      <Route path="admin" element={<Admin />}>
        {adminRoutes}
      </Route>
     
      <Route path="group">
        <Route
          index
          element={<Group />}
          loader={groupListLoader}
        />
        <Route
          path=":groupEntityId"
          element={<GroupDetail />}
          loader={groupDetailLoader}
        />
        <Route
          path="create"
          element={<Create />}
          action={groupCreateAction}
          loader={testAdminLoader}
        />
        <Route
          path="delete"
          element={<Delete />}
          action={groupDeleteAction}
          loader={groupLoader}
        />
        <Route
          path="edit"
          element={<Edit />}
          action={groupUpdateAction}
          loader={groupLoader}
        />
      </Route>
      <Route
        id="contact"
        path="contact"
        element={<Contact />}
        action={contactCreateAction}
        loader={contactLoader}
      />
      <Route
        id="faq"
        path="faq"
        element={<Faq />}
        action={contactCreateAction}
        loader={contactLoader}
      />
      <Route path="terms" element={<Terms />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="event">
        <Route index element={<EventPage />} loader={upcomingEventLoaders} />
        <Route
          path="previous"
          element={<EventPage />}
          loader={previousEventLoader}
        />
        <Route
          path="new"
          element={<EventCreate />}
          action={eventCreateAction}
          loader={groupListLoader}
        />
        <Route
          path="update/:id"
          element={<UpdateEvent />}
          loader={eventLoader}
          action={eventUpdateAction}
        />
        <Route
          path="pending"
          element={<PendingEvents />}
          loader={pendingEventLoaders}
        /> */}
      {/* </Route> */}
      <Route exact path="*" element={<FourZeroFour />} />
    </Route>,
  ),
);

export default function Router() {
  return <RouterProvider router={router} />;
}
